import React from "react";
import { Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import InlineEditor from "@ckeditor/ckeditor5-build-inline";
import "./HtmlSetting.css";

function HtmlSetting(props) {
  const [value, setValue] = React.useState(props.setting.value);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <div style={{ height: 340 }}>
              <Typography>{props.label}</Typography>
              <div style={{ border: "1px solid grey", borderRadius: 3 }}>
                <CKEditor
                  editor={InlineEditor}
                  data={value}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    props.onChange(editor.getData());
                    console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log("Focus.", editor);
                  }}
                />
              </div>
            </div>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default HtmlSetting;
